import { cva } from '@/styled-system/css';

export const avatarRecipe = cva({
  base: {
    position: 'relative',
    maxWidth: '100%',
    aspectRatio: '1/1',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'Avatar.Root.default',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.Avatar.Root.default} var(--shadow-color)',
      _focusVisible:
        'inset 0 0 0 {borderWidths.Avatar.Root.default} var(--shadow-color), {shadows.focus}',
    },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    tone: {
      'default': {
        backgroundColor: 'Avatar.Root.bg',
        boxShadowColor: 'Avatar.Root.border',
        color: 'Avatar.Root.text',
      },
      'brand-hero': {
        backgroundColor: 'Avatar.Root.brand.hero.bg',
        boxShadowColor: 'Avatar.Root.brand.hero.border',
        color: 'Avatar.Root.brand.hero.text',
      },
      'accent-1': {
        backgroundColor: 'Avatar.Root.accent.1.bg',
        boxShadowColor: 'Avatar.Root.accent.1.border',
        color: 'Avatar.Root.accent.1.text',
      },
      'accent-2': {
        backgroundColor: 'Avatar.Root.accent.2.bg',
        boxShadowColor: 'Avatar.Root.accent.2.border',
        color: 'Avatar.Root.accent.2.text',
      },
      'accent-3': {
        backgroundColor: 'Avatar.Root.accent.3.bg',
        boxShadowColor: 'Avatar.Root.accent.3.border',
        color: 'Avatar.Root.accent.3.text',
      },
      'accent-4': {
        backgroundColor: 'Avatar.Root.accent.4.bg',
        boxShadowColor: 'Avatar.Root.accent.4.border',
        color: 'Avatar.Root.accent.4.text',
      },
    },
    size: {
      xs: {
        textStyle: 'body-sm-bold',
        width: 'Avatar.Root.xs.size',
        height: 'Avatar.Root.xs.size',
      },
      sm: {
        textStyle: 'body-bold',
        width: 'Avatar.Root.sm.size',
        height: 'Avatar.Root.sm.size',
      },
      md: {
        textStyle: 'heading-xs',
        width: 'Avatar.Root.md.size',
        height: 'Avatar.Root.md.size',
      },
      lg: {
        textStyle: 'heading-sm',
        width: 'Avatar.Root.lg.size',
        height: 'Avatar.Root.lg.size',
      },
      xl: {
        textStyle: 'heading-md',
        width: 'Avatar.Root.xl.size',
        height: 'Avatar.Root.xl.size',
      },
      xxl: {
        textStyle: 'heading-lg',
        width: 'Avatar.Root.xxl.size',
        height: 'Avatar.Root.xxl.size',
      },
    },
  },
});
